module.exports = __webpack_public_path__ + "assets/plane.e461ef07.svg";